(function($) {
    var animation_interval = [],
        frame = [],
        increment = [],
        frames = [];

    function draw_png(png_object, ele_index) {
        if (typeof ele_index == 'undefined') {
            return;
        }

        png_object.addClass('drawn');
        frame[ele_index] = parseFloat(0);
        increment[ele_index] = parseFloat(png_object.attr('data-increment'));
        frames[ele_index] = parseFloat(png_object.attr('data-frames'));

        animation_interval[ele_index] = setInterval(function () {
            frame[ele_index] -= increment[ele_index];
            png_object.css({
                'background-position': 'center ' + frame[ele_index] + 'px'
            });


            if ((frame[ele_index] - increment[ele_index]) <= (frames[ele_index] * increment[ele_index] * -1)) {
                clearInterval(animation_interval[ele_index]);
            }
        }, 25);
    }

    $(window).on('load resize', function () {
        $('.sprite-anim').each(function () {
            var png_scale = 1 / 800 * window.innerWidth;

            if (png_scale > 1) {
                png_scale = 1;
            }

            $(this).css({
                'transform': 'translateX(-50%) scale(' + png_scale + ')'
            });
        });
    });

    $(window).on('load', function () {
        var count = 0;
        $('.sprite-anim').each(function () {
            let $this = $(this);
            $(this).attr('data-i', count);
            setTimeout(function () {
                draw_png($this, count);
            }, 1000);
            count++;
        });
    });




})( jQuery );